export default __webpack_public_path__ + "static/media/icons - Edit.b5dfeb6f.svg";